import {
  api,
  getOptions,
} from './helpers';

const submit = (payload) => api.post('/childrenBook/submit', payload, getOptions());

export default {
  submit,
};
